import React from 'react';
import cn from '@/utils/cn';

interface ArrowProps {
  isDisabled?: boolean,
  onClick?: () => void,
  arrowClass?: string,
}

const Arrow = ({ isDisabled, onClick, arrowClass }: ArrowProps) => (
  <button
    className={cn(arrowClass, { 'tw-hidden': isDisabled },
      'tw-bg-transparent tw-border-0 tw-cursor-pointer tw-flex tw-flex-col tw-justify-center tw-opacity-1',
      'tw-select-none')}
    type="button"
    onClick={onClick}
  />
);

export default Arrow;
